import type { Dictionnaire } from '../type';

export const legal: Dictionnaire['legal'] = {
  documents: {
    cgu: '使用条款',
    confidentialite: '隐私政策',
    mentions: '法律声明',
    version: (v: string) => `版本 ${v}`,
  },
  consentement: {
    titrePlusieurs: '我们的文件已更新',
    titreUn: '一份文件已更新',
    textePlusieurs: '要继续使用 Sirocco，请阅读并接受下面的两份文件。',
    texteUn: '要继续使用 Sirocco，请阅读并接受下面的文件。',
    accepter: '接受并继续',
    deconnecter: '退出登录',
  },
  ecran: {
    resumeCgu: '使用 Sirocco 时你所同意的内容。',
    resumeConfidentialite: '收集哪些数据、为什么收集、保存多久。',
    resumeMentions: '谁发布这款应用、谁托管它、如何联系我们。',
    titre: '条款与隐私',
    accepte: (cgu: string, confidentialite: string, quand: number | null) =>
      `你${quand ? `于 ${new Date(quand).toLocaleDateString('zh-CN')} ` : ''}接受了使用条款第 ${cgu} 版和隐私政策第 ${confidentialite} 版。`,
  },
  lien: {
    impossible: '无法打开页面。地址如下：',
  },
  miseAJour: {
    texte: '此版本包含应用无法自行安装的更新。',
    plusTard: '稍后',
    mettreAJour: '更新',
    disponible: (version: string) => `Sirocco ${version} 已发布`,
  },
};
